import type { Order } from "@/lib/projects";
import type { ProjectTimesheet } from "@/lib/projectOverview";
import { TimesheetsSection } from "@/projectOverview/sections/TimesheetsSection";
import {
  userCanCreateTimesheetsFromOverview,
} from "@/projectOverview/permissions";
import type { CurrentUser } from "@/lib/auth";
import { buildOverviewEvidenceList } from "@/projectOverview/timesheetDisplay";

export function countProjectCompletions(
  project: Order,
  timesheets: ProjectTimesheet[],
  festpreisMode: boolean,
): number {
  const items = buildOverviewEvidenceList(project, timesheets);
  if (festpreisMode) {
    return items.filter((item) => item.kind !== "schadensmeldung").length;
  }
  return items.filter((item) => item.kind === "completion").length;
}

export function ProjectCompletionsTab({
  project,
  timesheets,
  user,
  groups,
}: {
  project: Order;
  timesheets: ProjectTimesheet[];
  user: CurrentUser | null;
  groups: string[];
}) {
  const canCreate = userCanCreateTimesheetsFromOverview(user, groups);

  return (
    <div className="eh-project-completions-tab">
      <TimesheetsSection
        project={project}
        timesheets={timesheets}
        canCreate={canCreate}
        variant="completions"
      />
    </div>
  );
}
